<template>
    <div v-if="lessons" id="content">
        <h2 v-if="activeSearch" class="search-heading">Search Results</h2>
        <section v-for="(category, index) in lessons" :key="index">

            <template v-if="(activeFilters.length < 1 && activeSearch.length < 1) || (activeFilters.length > 0 && filterCategory(category.lessons)) || (activeSearch.length > 0 && searchCategory(category.lessons))">

                <header 
                    class="section-header" 
                    :style="category.secondary && category.image ? ('background-color:' + category.secondary) + ('; background-image: url(' + category.image + ')')  : ''"
                >
                    <h3 class="lesson-category-title">{{ category.title }}</h3>
                    <div class="lesson-category-count">
                        <strong class="number-of-lessons">{{ category.number_of_lessons }}</strong> Lessons
                    </div>
                </header>

                <main class="section-content">

                    <p class="category-description" v-text="category.description"></p>

                    <ul v-if="category.lessons" class="lessons">
                        <li v-for="lesson in category.lessons" :key="lesson.ID" class="lesson" :style="!filterLessons(lesson.filters) ? 'height:0;opacity:0;' : ''">
                            <template v-if="isSearched(lesson.title)">
                                <label class="radio-button-container" :class="{'selected': lessonSelected === lesson}">
                                    <span class="lesson-title">{{ lesson.title }}</span>
                                    <div class="lesson-description" v-html="lesson.description"></div>
                                    <input name="lesson" type="radio" @click="lessonSelected = lesson; image = category.image; backgroundColor = category.secondary; buttonColor = category.primary" :value="lesson.ID">
                                    <span class="radio-button"></span>
                                </label>
                            </template>
                        </li>
                    </ul>

                </main>

            </template>

        </section>
    
        <div v-show="lessonSelected" class="container embed-btn-container">
            <div class="row">
                <div class="col-sm-12">
                    <button class="btn embed-btn"  data-bs-toggle="modal" data-bs-target="#modal">Embed this lesson</button>
                </div>
            </div>
        </div>

    </div>

    <Modal :lesson="lessonSelected" :image="image" :backgroundColor = backgroundColor :buttonColor = buttonColor />

</template>

<script>
import Modal from './Modal.vue';

export default {
    name: "Content",
    props: ["lessons", "activeFilters", "activeSearch"],
    components: {
        Modal
    },
    data() {
        return {
            lessonSelected: false,
            image: false,
            backgroundColor: false,
            buttonColor: false
        }
    },
    methods: {
        filterLessons: function(lessonFilters){
            if (this.activeFilters.length > 0 && typeof lessonFilters !== 'undefined' && lessonFilters.length > 0){
                return lessonFilters.some(item => this.activeFilters.includes(item))
            }
            return true;
        },
        filterCategory: function (categoryLessons){
            let showCategory = [];
            for (let i=0; i<categoryLessons.length; i++){
                if (this.filterLessons(categoryLessons[i].filters)){
                    showCategory.push(categoryLessons[i]);
                }
            }
            return (showCategory.length > 0);

        },
        isSearched: function(lessonTitle){
            if (this.activeSearch.length > 0 && lessonTitle.length > 0){
                return lessonTitle.toLowerCase().includes(this.activeSearch.toLowerCase().trim());
            }
            return true;
        },
        searchCategory: function(lessons){
            let lessonsFiltered = [];
            for (let i=0; i<lessons.length; i++){
                if (this.isSearched(lessons[i].title.trim())){
                    lessonsFiltered.push(lessons[i]);
                }
            }
            return (lessonsFiltered.length > 0);
        }
    }
}
</script>

<style lang="scss" scoped>

    .search-heading {
        font-family: $fontBold;
        font-size: 18px;
        padding: 18px 30px;
        background-color: var(--color-hilight-orange);
        border-radius: 10px;
        margin-bottom: 2rem;
    }

    .section-header {
        display: flex;
        align-items: center;
        height: 100px;
        padding: 0 30px;
        border-radius: 10px;
        background-color: var(--color-off-white);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 150px auto;

        &:hover {
            cursor: default;
        }

        .lesson-category-title, .lesson-category-count {
            font-size: 18px;
        }
        .lesson-category-title {
            margin-right: auto;
            margin-bottom: 0;
            width: 250px;
            max-width: 100%;
        }
        .lesson-category-count {
            margin-left: auto;
        }
    }

    .section-content {
        padding: 15px 0;

        .lessons {
            list-style-type: none;
            padding-left: 0;

            .lesson {
                position: relative;
                transition: all 0.6s ease-in-out;
                height: 100%;
                opacity: 1;

                .radio-button-container {
                    padding: 16px 26px;
                    margin-left: 40px;
                    border-radius: 10px;
                    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
                    user-select: none;
                    display: block;

                    &:hover, &.selected {
                        color: var(--color-white);
                        background-color: var(--color-dark-grey);
                    }

                    &:hover {
                        cursor: pointer;
                    }

                    .lesson-title {
                        display: block;
                        font-family: $fontBold;
                        font-weight: bold;
                    }

                    .lesson-description {
                        display: block;
                        line-height: 1.4;
                        font-size: 0.9rem;

                        p {
                            margin-bottom: 0.5rem;
                        }

                    }

                    input {
                        position: absolute;
                        opacity: 0;
                        cursor: pointer;
                        height: 0;
                        width: 0;

                        &:checked ~ .radio-button:after {
                            display: block;
                        }

                    }

                    .radio-button {
                        position: absolute;
                        top: 16px;
                        left: 0;
                        height: 25px;
                        width: 25px;
                        border-radius: 50%;
                        border: 1px solid #000000;

                        &:after {
                            content: "";
                            position: absolute;
                            display: none;
                            top: 4px;
                            left: 4px;
                            width: 15px;
                            height: 15px;
                            border-radius: 50%;
                            background: var(--color-crimson);
                        }

                    }

                }

            }

        }

    }

    .embed-btn-container {
        position: fixed;
        text-align: right;
        bottom: 1rem;
        right: 0;
        left: 0;
        margin-right: auto;
        padding-right: calc(var(--bs-gutter-x) / 2);

        .embed-btn {
            background-color: var(--color-crimson);
            color: var(--color-white);
            padding: 12px 18px;
            border-radius: 15px;
            font-size: 14px;
            box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.25);
            opacity: 0.9;
            transition: opacity 0.3s ease-in-out;

            &:hover {
                opacity: 1;
            }

        }
    }

</style>